import { FaFacebookF } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";

export const socialNetworks = [
  {
    id: 1,
    icon: <FaFacebookF />,
    link: "/",
  },
  {
    id: 2,
    icon: <FaWhatsapp />,
    link: "/",
  },
  {
    id: 3,
    icon: <FaLinkedin />,
    link: "/",
  },
  {
    id: 4,
    icon: <FaYoutube />,
    link: "/",
  },
];
